<script lang="ts">
	import { lazyLoader } from "$lib/utils/lazyloader";
  import classnames from "classnames"
  
  export let lazyLoad: boolean = false;

  export let image: string | null = null;
  export let srcset: string | null = null;
  export let imageAlt: string | null = null;
  export let title: string;
</script>

<div class="{classnames('certificate', $$props.class)}">
  {#if image}
    <div class="certificate-image">
      {#if lazyLoad}
        <img use:lazyLoader={image} {srcset} alt={imageAlt} />
      {:else}
        <img src={image} {srcset} alt={imageAlt} />
      {/if}
    </div>
  {/if}
  <p class="certificate-title">{@html title}</p>
</div>

<style type="text/scss" lang="scss" scoped>
  .certificate {
    @apply flex flex-col items-center;
    @apply px-2;
    @apply text-gray-900;
    @apply py-4;
  }

  .certificate-image {
    @apply h-18;
    @apply flex justify-start;

    img {
      @apply max-w-full h-auto;
      @apply object-contain object-top;
    }
  }

  .certificate-title {
    @apply mt-3;
    @apply text-center;
  }
</style>
